import { FASTCOMMENTS_APP_ID } from '@/constants/env';

export enum CommentWidgetTranslations {
  LOG_IN_TO_COMMENT = 'Log in or Sign up to Comment.',
}

export const FastCommentsCountBaseUrl = `https://fastcomments.com/widgets/comment-count/${FASTCOMMENTS_APP_ID}?urlId=`;
